import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axios } from 'app-zephyr-axios';
import { CREATE_ORG_PATH, CreateOrganizationBody } from 'ze-api-contract/organization-v2/crud-organization';

import { navigationItemsQuery } from '../user/navigation-items';

export function useCreateOrganization() {
  const queryClient = useQueryClient();
  const { queryKey } = navigationItemsQuery.organizationList();
  return useMutation({
    mutationFn: (organization: CreateOrganizationBody) => axios.post(CREATE_ORG_PATH, organization),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey });
    },
  });
}
